import {IItemContent} from "@connox/typescript-library";
import React from "react";
import {Translation} from "react-i18next";
import styled from "styled-components";
import RatingStars from "../../lib/ratingStars/RatingStars";

const PriceVotedDiv = styled.div`
  width: 100%;
  display: block;
  color: #000;
  text-decoration: none;
  margin-top: 0.5rem;
  white-space: normal;
  .price {
    display: inline-block;
    font-weight: 400;
    margin-right: 8px;
  }
  s {
    font-size: 0.85rem;
    font-weight: 400;
  }
`;

const DescriptionDiv = styled.div`
  display: inline-block;
  width: 100%;
  line-height: 1.3rem;
  height: 2.6rem;
  overflow: hidden;
  white-space: normal;
`;

const CardWrapAnchor = styled.a`
  flex: 0 0 auto;
  width: calc((100% - 2rem) / 1.5);
  margin-right: 1rem;
  margin-left: 0;
  padding-left: 1rem;
  color: #000;
  text-decoration: none;
  white-space: normal;
  vertical-align: top;
  scroll-snap-align: start;
  position: relative;
  img {
    width: 90%;
    margin-left: 5%;
    margin-bottom: 0;
  }
  @media only screen and (min-width: 480px) {
    display: inline-block;
    width: 25%;
    margin: 0 0 1rem 0;
    padding: 0 0.5rem 1rem 0.5rem;
    box-sizing: border-box;
    border: 1px solid #fff;
    img {
      width: 70%;
      margin-left: 15%;
      margin-bottom: 0;
    }
    &:hover {
      border: 1px solid #ddd;
    }
    &:nth-child(4n) {
      margin-right: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  @media only screen and (max-width: 350px) {
    width: calc((100% - 1rem) / 1.5);
  }
`;

const TopBadge = styled.span`
  position: absolute;
  top: 14px;
  left: 8px;
  width: 2rem;
  height: 1.3rem;
  line-height: 1.3rem;
  font-size: 0.7rem;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  vertical-align: bottom;
  background-color: #5fc1ff;
  @media only screen and (max-width: 480px) {
    left: 16px;
  }
`;

const SaleBadge = styled(TopBadge)`
  background-color: red;
  &:after {
    content: "%";
    font-size: 0.7em;
  }
`;

const NewBadge = styled(TopBadge)`
  background-color: #16e600;
`;

const ProductCard: React.FC<IItemContent> = (props) => {
  const {daysSincePublishing, images, itemId, itemRank, prices, ratingAverage, title, url} = props;
  const {advertise, discountPercentage, price, retail} = prices[0];

  const Badge: React.FC = () => {
    if (discountPercentage && discountPercentage > 5) {
      return <SaleBadge>{`-${discountPercentage}`}</SaleBadge>;
    } else if (itemRank && itemRank < 300) {
      return <TopBadge>TOP</TopBadge>;
    } else if (daysSincePublishing && daysSincePublishing < 30) {
      const lang = document.body.dataset.lang;
      const newText = lang && lang === "de" ? "NEU" : "NEW";

      return <NewBadge>{newText}</NewBadge>;
    } else {
      return null;
    }
  };

  if (!images[0].sizes) {
    return null;
  }

  const pictureSize = images[0].sizes.find((size) => size.name === "thumbnail-3x");
  if (!pictureSize) {
    return null;
  }

  const pictureUrl = pictureSize.url;

  return (
    <Translation>
      {(t) => (
        <CardWrapAnchor href={url}>
          <img src={pictureUrl} alt={title} />
          <Badge />
          <DescriptionDiv>{title}</DescriptionDiv>
          <PriceVotedDiv>
            <span className="price">
              {advertise && (
                <>
                  <s>{t("UVP {{price}}", {price: retail.formatted})}</s>&nbsp;
                </>
              )}
              <span className={advertise ? "red" : undefined}>{price.formatted}</span>&nbsp;*
            </span>
            {!!ratingAverage.count && (
              <RatingStars metaprops={false} rating={ratingAverage.average / 20} size="small" />
            )}
          </PriceVotedDiv>
        </CardWrapAnchor>
      )}
    </Translation>
  );
};

export default ProductCard;
